import { Link } from "react-router-dom";
import evcloudLogo from "../../../assets/images/evcloud-logo.svg";
import { Img } from "../../../styles/commonStyle";
import { TenantHeaderBox } from "./style";

function TenantHeader() {
  return (
    <TenantHeaderBox>
      <Link to="/">
        <Img src={evcloudLogo} alt="evCloud" height="24px" />
      </Link>
    </TenantHeaderBox>
  );
}

export default TenantHeader;
